'use client';

import React from 'react';
import { ClockIcon, TrendingUpIcon, UsersIcon, ShieldCheckIcon, ZapIcon, TargetIcon } from 'lucide-react';
export function BenefitsB2B() {
  const benefits = [{
    icon: <ClockIcon className="h-6 w-6" data-id="element-702" />,
    title: 'Cierra ventas más rápido',
    description: 'Reduce los plazos desde la reserva hasta la aprobación del crédito. De semanas de espera a pocos días con respuestas claras.',
    stat: '4x',
    statLabel: 'más rápido'
  }, {
    icon: <TrendingUpIcon className="h-6 w-6" data-id="element-703" />,
    title: 'Mejor conversión de promesas',
    description: 'Menos operaciones que se caen por evaluación tardía. Más promesas que llegan a escritura.',
    stat: '+35%',
    statLabel: 'más conversión'
  }, {
    icon: <UsersIcon className="h-6 w-6" data-id="element-704" />,
    title: 'Clientes con claridad desde el inicio',
    description: 'Tus compradores saben cuánto podrían pedir y cuánto pagarían. Menos dudas, menos fricción en el cierre.',
    stat: '98%',
    statLabel: 'satisfacción'
  }, {
    icon: <ShieldCheckIcon className="h-6 w-6" data-id="element-705" />,
    title: 'Evaluación en múltiples bancos',
    description: 'Un solo flujo para revisar el perfil del cliente en varias instituciones. Más opciones y mejores probabilidades de aprobación.',
    stat: '5+',
    statLabel: 'instituciones'
  }, {
    icon: <ZapIcon className="h-6 w-6" data-id="element-706" />,
    title: 'Proceso ordenado y 100% digital',
    description: 'Documentos, estado de avance y resultados en un solo lugar. Menos WhatsApps sueltos, más control del proceso.',
    stat: '100%',
    statLabel: 'online'
  }, {
    icon: <TargetIcon className="h-6 w-6" data-id="element-707" />,
    title: 'Sin costo fijo para ti',
    description: 'No pagas por usar Creditual como corredor o inmobiliaria. Solo se cobra si el cliente obtiene su crédito con nosotros.',
    stat: '$0',
    statLabel: 'costo fijo'
  }];
  return <section id="beneficios-b2b" className="relative py-16 md:py-24 bg-[#F3F4F6]" data-id="element-708">
      {/* fondo sutil decorativo */}
      <div className="pointer-events-none absolute inset-0 opacity-60" data-id="element-709">
        <div className="absolute -top-24 -right-10 h-56 w-56 rounded-full bg-gradient-to-br from-[#2B5FD9]/10 to-[#1E4BB8]/5 blur-2xl" data-id="element-710" />
        <div className="absolute -bottom-16 -left-10 h-60 w-60 rounded-full bg-gradient-to-tr from-[#2B5FD9]/10 to-transparent blur-3xl" data-id="element-711" />
      </div>

      <div className="relative container mx-auto max-w-7xl px-4" data-id="element-712">
        <div className="text-center mb-12 md:mb-16" data-id="element-713">
          <span className="inline-flex items-center rounded-full bg-white/80 border border-[#E5EDFF] text-[#2B5FD9] px-3 py-1 text-xs font-medium mb-4" data-id="element-714">
            Pensado para corredores e inmobiliarias
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-3" data-id="element-715">
            Por qué los corredores eligen Creditual
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-2xl mx-auto" data-id="element-716">
            Centraliza la evaluación hipotecaria, reduce la incertidumbre y
            protege tus cierres con una experiencia más profesional para ti y
            tus clientes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-717">
          {benefits.map(benefit => <div key={benefit.title} className="group h-full bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-7 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-[#2B5FD9]/30 hover:-translate-y-1" data-id="element-718">
              {/* Header: icono + stat a la derecha */}
              <div className="flex items-start justify-between mb-5" data-id="element-719">
                <div className="inline-flex items-center justify-center rounded-xl bg-[#E5EDFF] text-[#2B5FD9] p-3" data-id="element-720">
                  {benefit.icon}
                </div>
                <div className="text-right" data-id="element-721">
                  <div className="text-xs uppercase tracking-wide text-[#9CA3AF]" data-id="element-722">
                    {benefit.statLabel}
                  </div>
                  <div className="text-2xl font-bold text-[#2B5FD9]" data-id="element-723">
                    {benefit.stat}
                  </div>
                </div>
              </div>

              {/* Título y descripción */}
              <h3 className="text-lg md:text-xl font-semibold text-[#0A1628] mb-2 group-hover:text-[#2B5FD9] transition-colors" data-id="element-724">
                {benefit.title}
              </h3>
              <p className="text-sm text-[#6B7280] leading-relaxed mb-4" data-id="element-725">
                {benefit.description}
              </p>

              {/* Línea inferior sutil */}
              <div className="mt-auto pt-3 border-t border-dashed border-gray-200" data-id="element-726">
                <p className="text-[11px] uppercase tracking-wide text-[#9CA3AF]" data-id="element-727">
                  Integrable a tu proceso de venta
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}